<div class="page-tab">
  <div class="page-tab__dividers">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="page-tab__buttons">
    @for (tab of tabconfig(); track tab.keyword) {
      <button
        class="page-tab__button"
        (click)="select(tab)"
        [class.active]="activeTabIndex() === $index"
        [disabled]="disabled()"
      >
        {{ tab.translationKeyword | translate }}
      </button>
    }
  </div>
</div>
